<template>
  <span @click.capture='checkAuthenticated'>
    <slot></slot>
  </span>
</template>

<script>
export default {
  props: {
    notice: {
      type: String,
      default: 'You need to be logged in to do that'
    }
  },

  methods: {
    checkAuthenticated(event) {
      const isAuthenticated = this.$root.$data.current['authenticated']

      if (!isAuthenticated) {
        event.preventDefault()
        event.stopPropagation()
        window.location.assign(`/auth/redirect?notice=${encodeURIComponent(this.notice)}`)
      }
    }
  }
}
</script>